import darkTheme from './dark';
import lightTheme from './light';
import defaultTheme from './default';

export default [defaultTheme, darkTheme, lightTheme];
